module.exports = "/images/icon-locked.svg?4784562132f3b9d44211056d621c5739";